<script>
    import { createEventDispatcher } from 'svelte';
    import { notificate } from '../../services/notification.js';
    import { form as svForm  } from 'svelte-forms';
    import findingService from './v2-service.js';
    import * as utils from '../../js/utils.js';
    import { format } from 'svelte-i18n';

    export let properties;

    for(let prop of properties){
        prop.location = utils.removeTags(prop.location);
        prop.location = prop.location === 'General' ? "" : prop.location;
    }

    const dispatch = createEventDispatcher();

    let customProps = JSON.parse(JSON.stringify(properties));
    let disableSubmit = true;
    let propsToDelete = [];
    let formDataPromise;
    let formData = {};
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    // API 422 errors
    let formApiErrors = {};
    let inputElement;

    const isJson = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    function handleSubmit() {

        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        findingService.deleteProps(propsToDelete, [], {})
            .then(response=>dispatch("saveProp"))
            .catch(error=>dispatch("saveProp"))
        ;
        formIsSubmitted = false;
        formApiErrors = {};
        APIerror = null;
        return true;
    }
    
    function handleCloseModal(){
        formIsSubmitted = false;
        customProps = properties;
        
        // THIS WAS MISSING: Tell the parent to actually close the modal!
        dispatch('cancel'); 
    }

    const removeCustomProp = (id) =>{
        propsToDelete.push(id);
        customProps = customProps.filter(prop=>prop.id != id);
        customProps = customProps;
        disableSubmit = false;
    }

    const handleKeydown = event => {

        if(event.key == "Escape"){
            handleCloseModal();
        }
        else {
            return;
        }
    }
</script>

<style>
    label {
        display: block;
        clear: both;
    }
    .customPropContainer{
        clear: both;
        height: 100%;
        overflow: hidden;
        border: 1px solid #ccc;
        padding: 1em;
        margin-top: 1em;
    }
    .customPropContainer label {
        margin-bottom: 0;
        margin-top: 1em;
    }
    .customPropContainer input {
        margin-top: 1em;
        margin-bottom: 1em;
    }
    .prop-input{
        max-width: 94%;
    }
</style>


<svelte:window on:keydown={handleKeydown}/>

<form role="form" novalidate on:submit|preventDefault={handleSubmit}>
    <div class="card">
        <div class="card-body">
            {#await formDataPromise then formDataUnused}
                <div class="mb-3">
                    <div class="mb-3" style="height: 100%;overflow: hidden;clear: both;">
                        {#if customProps.length > 0}
                            {#each customProps as prop, i}
                                <div class="customPropContainer">
                                    <div><strong>Tipo</strong>:
                                    <span>{customProps[i].kind || ''}</span></div>
                                    <div><strong>{$format("form.fields.name")}</strong>:
                                    <span>{customProps[i].name || ''}</span></div>
                                    <div><strong>Valor</strong>:
                                    <span>{customProps[i].value || ''}</span></div>
                                    <div><strong>Ubicación</strong>:
                                    <span>{customProps[i].location || ''}</span></div>
                                    <button class="btn btn-default" title="Quitar propiedad" style="margin-top:1rem; position: relative; margin-left: 0em;" on:click|preventDefault={()=>removeCustomProp(prop.id)}><i class="fas fa-times" style="font-size: 1rem; color: rgba(160, 33, 40, 0.9);"></i> Quitar propiedad</button>
                                </div>
                            {/each}
                        {:else}
                            <div>No se encontraron propiedades</div>
                        {/if}
                    </div>
                </div>
            {/await}
        </div>
        <div class="card-footer">
            <button id="findingPropsDeleteSubmit" type="submit" class="btn btn-primary t-submit-source-code-btn" disabled={disableSubmit}>{$format("buttons.save")}</button>
            <!-- REMOVED data-bs-dismiss="modal" so Svelte controls the closing -->
            <button type="button" class="btn btn-default" on:click={handleCloseModal}>{$format("buttons.cancel")}</button>
        </div>
        {#await formDataPromise}
        <div class="overlay">
            <i class="fas fa-2x fa-sync-alt fa-spin" />
        </div>
        {/await}
    </div>
</form>